import { Component } from '@angular/core';
import { JobConstants } from '../../../../common/utils/job-constants';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { ClientUtilities } from '../../../utils/client-utils';


@Component({
    selector: 'networking-vcd',
    styles: [require('./networking-vcd.scss')],
    template: require('./networking-vcd.html')
})
export default class NetworkingVcdView {

    private isActivityLogVisible: boolean = false;
    private isVsphereClient = false;

    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    private activityLogService = JobConstants.SERVICES['NetworkingServiceJobV1'] + ','
        + JobConstants.SERVICES['DirectConnectJob'];

    private activityLogFilter = 'workflowType='
        + JobConstants.WORKFLOW_JOB_TYPES.DEFAULT + ','
        + JobConstants.WORKFLOW_JOB_TYPES.CREATE_EDGE_GATEWAY_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.UPDATE_EDGE_GATEWAY_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.DELETE_EDGE_GATEWAY_JOB;


    ngOnInit() {
        this.isVsphereClient = ClientUtilities.runningInPluginUI();
    }

    onTabIndexChanged(event){
        this.isActivityLogVisible = (event === 1) ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vcd/networking-vcd.components.ts